<template>
  <div
    ref="table-menu"
    class="result-table__settings rtset"
    :class="{ rtset_off: !listVisible }"
  >
    <button class="button_clean rtset__button">
      <svg width="20" height="20" @click="handleButtonClicked">
        <use xlink:href="#settings" />
      </svg>
    </button>

    <v-draggable
      v-if="listVisible"
      v-click-outside="() => (listVisible = false)"
      class="rtset__list"
      :list="fieldsList"
      handle=".rtset__draggable"
      @start="setDrag"
      @end="resetDrag"
      @change="handleListOrderChanged"
    >
      <div
        v-for="(field, num) in fieldsList"
        :key="`${num}_${field.name}`"
        class="rtset__item"
      >
        <div
          :class="`rtset__checkbox ${currActive <= 3 ? 'disabled' : ''}`"
          :title="
            `${
              currActive <= 3 && field.active
                ? 'Количество отображаемых полей не менее 3-х'
                : 'Кликните для изменения видимости столбца'
            }`
          "
          @click="changeFieldActivity(num)"
        >
          <svg
            :class="field.active ? 'checked' : 'non-checkbox'"
            width="14"
            height="14"
          >
            <use
              v-bind:xlink:href="
                field.active ? '#checkbox-checked' : '#checkbox'
              "
            />
          </svg>
          <span>{{ field.label }}</span>
        </div>
        <svg class="rtset__draggable" width="15" height="15">
          <use xlink:href="#draggable" />
        </svg>
      </div>

      <div class="rtset__reset" @click="handleResetSettings">
        Сбросить
      </div>
    </v-draggable>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

import VDraggable from 'vuedraggable';

export default {
  components: {
    VDraggable
  },

  data() {
    return {
      listVisible: false,
      dragInProcess: false
    };
  },

  computed: {
    ...mapGetters({
      tableConfig: 'searchTableConfig',
      currActive: 'activeTableConfigItems'
    }),
    fieldsList() {
      return this.tableConfig.map(i => {
        return {
          name: i.name,
          label: i.label,
          active: i.active
        };
      });
    }
  },

  methods: {
    setDrag() {
      this.dragInProcess = true;
    },
    resetDrag() {
      this.dragInProcess = false;
    },
    handleButtonClicked() {
      this.listVisible = !this.listVisible;
    },
    handleListOrderChanged(ev) {
      this.$store.dispatch('setNewColsOrder', {
        newIndex: ev.moved.newIndex,
        oldIndex: ev.moved.oldIndex
      });
    },
    changeFieldActivity(num) {
      if (this.fieldsList[num].active && this.currActive <= 3) return;

      this.$store.dispatch('changeTableConfigProp', {
        name: this.fieldsList[num].name,
        prop: 'active',
        mode: !this.fieldsList[num].active
      });
    },
    handleResetSettings() {
      this.$store.dispatch('resetSearchResultsTableSettings');
    }
  }
};
</script>
